/**
 * Tooltip Component
 * Shows contextual help on hover (desktop) or tap (mobile)
 */

import React, { useState } from 'react';
import { Info } from 'lucide-react';

export default function Tooltip({ content, position = 'top' }) {
  const [show, setShow] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div className="relative inline-flex">
      <button
        type="button"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => setShow(!show)}
        className="text-slate-400 hover:text-slate-600 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 rounded"
        aria-label="More information"
      >
        <Info className="w-4 h-4" />
      </button>

      {show && (
        <>
          {/* Mobile backdrop */}
          <div
            className="fixed inset-0 z-30 sm:hidden"
            onClick={() => setShow(false)}
          />

          {/* Tooltip */}
          <div
            className={`absolute z-40 w-64 sm:w-72 px-3 py-2 text-xs leading-relaxed text-slate-700
                       bg-white border border-slate-300 rounded-lg shadow-lg
                       animate-fade-in ${positionClasses[position]}`}
          >
            {content}

            {/* Arrow */}
            <div
              className={`absolute w-2 h-2 bg-white border-slate-300 rotate-45
                         ${position === 'top' ? 'bottom-[-5px] left-1/2 -translate-x-1/2 border-b border-r' : ''}
                         ${position === 'bottom' ? 'top-[-5px] left-1/2 -translate-x-1/2 border-t border-l' : ''}
                         ${position === 'left' ? 'right-[-5px] top-1/2 -translate-y-1/2 border-r border-t' : ''}
                         ${position === 'right' ? 'left-[-5px] top-1/2 -translate-y-1/2 border-l border-b' : ''}`}
            />
          </div>
        </>
      )}
    </div>
  );
}
